module.exports = __webpack_public_path__ + "static/media/doc_browser_light@2x.6197494b.png";